export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="w-full lg:w-[35%]">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-semibold mb-5">
              <i className="ri-shield-check-line text-sm"></i>
              EEAT 2026
            </span>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Diverse%20creative%20team%20of%20three%20young%20professionals%20collaborating%20around%20laptop%20in%20bright%20modern%20co-working%20space%2C%20genuine%20smiles%20and%20engagement%2C%20Brazilian%20diverse%20workplace%2C%20tropical%20plants%20and%20colorful%20art%20on%20walls%2C%20natural%20daylight%20from%20skylight%2C%20creative%20agency%20atmosphere%2C%20authentic%20teamwork%20moment%2C%20warm%20vibrant%20office%20photography%2C%20energetic%20collaborative%20vibe%2C%20real%20human%20interaction&width=600&height=750&seq=about-v2-team&orientation=portrait"
                alt="Equipe CSSBuy Spreadsheet Brasil"
                className="w-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-[60%]">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              Transparência /
              <br />
              Comunidade /
              <br />
              Atualização
            </h2>
            <p className="text-foreground-500 text-base md:text-lg leading-relaxed mb-6 max-w-xl">
              Somos a Equipe CSSBuy Spreadsheet Brasil, especialistas em compras internacionais, agentes chineses e planilhas CSSBuy. Nosso compromisso é fornecer informações transparentes, atualizadas e verificadas para toda a comunidade de compradores brasileiros.
            </p>
            <p className="text-foreground-400 text-sm leading-relaxed mb-8 max-w-xl">
              Mantemos uma política editorial rigorosa: todos os links são verificados manualmente, o conteúdo é atualizado diariamente e as informações de segurança são sempre prioridade. Não aceitamos conteúdo patrocinado que comprometa nossa imparcialidade.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="/guia-de-compras"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Nossos Guias Completos
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="/guia-de-compras#guia-iniciantes"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-600 hover:border-foreground-400 hover:text-foreground-950 text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Para Iniciantes
                <i className="ri-user-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}